import * as yup from 'yup';

export const validationSchema = yup.object({
	calculatedVatDueSales: yup.number().required('Calculated VAT Due Sales is required'),
	calculatedVatDueAcquisitions: yup
		.number()
		.required('Calculated VAT Due Acquisitions is required'),
	calculatedTotalVatDue: yup.number().required('Calculated Total VAT Due is required'),
	calculatedVatReclaimedCurrPeriod: yup
		.number()
		.required('Calculated VAT Reclaimed Current Period is required'),
	calculatedNetVatDue: yup
		.number()
		.min(0, 'Calculated Net VAT Due must be a positive number')
		.required('Calculated Net VAT Due is required'),
	calculatedTotalValueSalesExVAT: yup
		.number()
		.required('Calculated Total Value Sales Ex VAT is required'),
	calculatedTotalValuePurchasesExVAT: yup
		.number()
		.required('Calculated Total Value Purchases Ex VAT is required'),
	calculatedTotalValueGoodsSuppliedExVAT: yup
		.number()
		.required('Calculated Total Value Goods Supplied Ex VAT is required'),
	calculatedTotalAcquisitionsExVAT: yup
		.number()
		.required('Calculated Total Acquisitions Ex VAT is required'),
});
